/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/** Ce que la situation matrimoniale du défunt autorise comme champs. */
export interface RegleEtatMatrimonial {
  /** Libellé du champ de date ; absent ⇒ cette situation n'a pas de date. */
  libelleDate?: string;
  /** Mot désignant l'ancien conjoint ; absent ⇒ pas de bloc conjoint. */
  roleConjoint?: 'conjoint' | 'partenaire';
  /** La situation antérieure au Pacs est-elle demandée ? */
  etatAnterieurPacs?: boolean;
}

/**
 * Champs autorisés par situation matrimoniale du défunt, indexés par le code du
 * référentiel (`ec_etamat.em_codj`).
 *
 * Règle métier, et non déduction des données : célibataire et union libre
 * n'admettent aucun champ complémentaire, trois situations seulement portent une
 * date, et le Pacs remplace cette date par la situation qui le précédait.
 *
 * Source unique : l'assistant, la modale et le descripteur de la fiche lisent
 * cette table, et l'API en applique l'équivalent à l'écriture. Trois copies de
 * la règle divergeraient au premier ajustement.
 */
export const REGLES_ETAT_MATRIMONIAL: Record<string, RegleEtatMatrimonial> = {
  C: {},
  D: { libelleDate: 'Divorcé(e) le', roleConjoint: 'conjoint' },
  M: { libelleDate: 'Marié(e) le', roleConjoint: 'conjoint' },
  P: { roleConjoint: 'partenaire', etatAnterieurPacs: true },
  S: { roleConjoint: 'conjoint' },
  U: {},
  V: { libelleDate: 'Veuf(ve) le', roleConjoint: 'conjoint' },
};

/**
 * Situations proposées comme antérieures à un Pacs, plus le choix vide.
 *
 * Sous-ensemble du référentiel du défunt : on filtre la liste déjà chargée
 * plutôt que d'interroger un second référentiel, `ec_etamat` n'ayant pas de
 * contexte dédié.
 */
export const CODES_ETAT_ANTERIEUR_PACS = ['D', 'U', 'V'];

/** Règle d'une situation, ou une règle vide si le code est inconnu ou absent. */
export const regleEtatMatrimonial = (
  code?: string | null,
): RegleEtatMatrimonial =>
  REGLES_ETAT_MATRIMONIAL[(code ?? '').trim().toUpperCase()] ?? {};

export default REGLES_ETAT_MATRIMONIAL;
